<div *ngIf="showBar" class="fixed-bottom w-25">
    <a class="m-3 btn btn-outline-info" (click)="expose()">
        EXPOSE CMS LINKS <i class="ml-2 fa fa-refresh"></i>
    </a>
</div>
